import { render } from "./vueRating.vue?vue&type=template&id=5eea9d2a"
import script from "./vueRating.vue?vue&type=script&lang=js"
export * from "./vueRating.vue?vue&type=script&lang=js"

import "./vueRating.vue?vue&type=style&index=0&id=5eea9d2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__